
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13073',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13073",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9888",
  "foundations-components": "static-1.8358",
  "foundations-components-legacy": "static-1.1383",
  "foundations-theming": "static-1.4684",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8256",
  "hub-http-shared-msw-handlers": "static-1.10496",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11711",
  "I18n": "static-7.1655",
  "jasmine-runner": "static-1.6679",
  "marketplace-discovery-studio-lib": "static-1.520",
  "marketplace-storefront-base": "static-1.13136",
  "quartz": "static-1.7341",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16937",
  "reactive-variable-buffer-atom": "static-1.3086",
  "reporting-testing-lib": "static-1.10442",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12751",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7532",
  "ui-addon-i18n": "static-1.11377",
  "ui-addon-react-router-dom": "static-1.9764",
  "unified-auth": "static-1.768",
  "unified-auth-core-lib": "static-1.1050",
  "usage-tracker": "static-1.7588",
  "usage-tracker-core": "static-1.7438",
  "customer-data-property-utils": "static-1.8329",
  "hub-http": "static-1.6444",
  "integrations-lib": "static-1.16880",
  "marketplace-ui-common": "static-1.20523",
  "marketplace-ui-install": "static-1.509",
  "property-management-iframe": "static-1.13925",
  "quartz-config": "static-1.1119",
  "quartz-core": "static-1.6560",
  "quartz-routing": "static-1.771",
  "quick-fetch": "static-1.4078",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4893",
  "ts-schema": "static-1.4240",
  "ui-universal-auth": "static-1.9254",
  "UIComponents": "static-3.8657",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3561",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3618",
  "quartz-webpack": "static-1.3565",
  "bend-plugin-quartz-routing": "static-1.419",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4627",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5106",
  "foundations-theming-specialty": "static-1.2400",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9657",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.55",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5502",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2416",
  "ui-fonts": "static-1.973",
  "ui-images": "static-2.1223",
  "bend-plugin-foundations-theming": "static-1.3167",
  "foundations-theming-base": "static-1.3669",
  "stylex": "static-1.37",
  "HeadJS": "static-2.785",
  "hs-test-utils-bend-plugin": "static-1.3367",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4549",
  "ui-addon-video-player": "static-1.8937",
  "ai-components-ui-library": "static-1.9544",
  "ai-rendering-library": "static-1.10962",
  "chirp-fetch": "static-1.2118",
  "connections-embed-lib": "static-1.1409",
  "copilot-toolkit": "static-1.11710",
  "feedback-loader": "static-1.29707",
  "laboratory-lib": "static-3.7382",
  "marketplace-embed": "static-1.22776",
  "marketplace-ui-details": "static-1.10418",
  "marketplace-ui-reviews": "static-1.20478",
  "marketplace-ui-tracking": "static-1.14693",
  "sanitize-text": "static-1.8379",
  "usage-tracker-multi": "static-1.6002",
  "usage-tracker-session-replay": "static-1.5274",
  "wootric-nps": "static-1.7147",
  "quartz-head": "static-1.1006",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4888",
  "immer": "static-1.94",
  "immerable": "static-1.4382",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2636",
  "reporting-data": "static-1.68509",
  "cssUtils": "static-1.862",
  "flux-actions": "static-1.357",
  "HubStyle": "static-2.12018",
  "PatternValidationJS": "static-1.3126",
  "react-colorpicker": "static-2.10438",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.71",
  "ReduxMessenger": "static-2.10596",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7578",
  "icons": "static-2.672",
  "marketplace-ui-apps-core": "static-1.19055",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4741",
  "foundations-components-test-utils": "static-1.5841",
  "quartz-i18n": "static-1.1016",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.315",
  "ads-unified-auth-lib": "static-1.893",
  "google-sheets-integration-lib": "static-1.894",
  "microsoft-drive-integration-lib": "static-1.1039",
  "surveymonkey-integration-lib": "static-1.338",
  "slack-ui-library": "static-1.10626",
  "fsm": "static-1.3968",
  "customer-data-objects": "static-1.7915",
  "property-translator": "static-1.5624",
  "hs-locale-management": "static-1.242",
  "frontend-preferences-client": "static-1.8159",
  "hs-promise-utils": "static-1.5826",
  "hubspot-apollo-client": "static-1.5108",
  "integrations-error-boundary-lib": "static-1.14296",
  "integrations-tracking-lib": "static-1.5839",
  "native-integrations-shared-strings": "static-1.8008",
  "sanitize": "static-1.4707",
  "superstore": "static-1.4987",
  "ui-shepherd-react": "static-3.10493",
  "ai-settings-ui-library": "static-1.8230",
  "hub-http-janus": "static-1.863",
  "hubspotter-http": "static-1.4810",
  "immutable-less": "static-1.4882",
  "marketplace-ui-client-types": "static-1.17930",
  "nav-meta": "static-1.30327",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18302",
  "ui-product-approvals-common": "static-1.852",
  "ai-studio-lib": "static-1.12305",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.382",
  "ui-addon-iframeable": "static-1.9307",
  "ui-addon-integrations-directory-panel": "static-2.8256",
  "ui-product-approvals": "static-1.28957",
  "ui-tool-access": "static-1.10384",
  "inbound-db-properties-service-client": "static-1.4005",
  "property-management-common": "static-1.6213",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.560",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1016",
  "quartz-test": "static-1.1016",
  "quartz-tracking": "static-1.720",
  "trellis-components": "static-1.2435",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.303",
  "bender-build-tools": "static-1.3356",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22546",
  "ContentUtils": "static-1.69020",
  "customer-data-objects-ui-components": "static-1.13262",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2728",
  "breeze-engine-core": "static-1.806",
  "breeze-onboarding-components": "static-1.580",
  "customer-data-filters-ui": "static-1.40694",
  "customer-data-reference-ui-components": "static-1.13409",
  "embedded-academy-lib": "static-1.15292",
  "ExportDialog": "static-6.10611",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41876",
  "reporting-snowflake": "static-1.57127",
  "reporting-ui-components": "static-2.65780",
  "reporting-visualizations": "static-1.60585",
  "trellis-theming": "static-1.1186",
  "ui-addon-teams": "static-1.21837",
  "upgrade-components-lib": "static-1.436",
  "magpie-lib": "static-1.5710",
  "navigation-components": "static-1.18690",
  "breeze-engine-lib": "static-1.1528",
  "magpie-types": "static-1.5170",
  "simple-logging-lib": "static-1.3280",
  "fail-safe": "static-1.181",
  "app-governance-lib": "static-1.2256",
  "developer-experience-shared-components": "static-1.10729",
  "purchase-motions-components": "static-1.6264",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9932",
  "usage-tracker-anonymous": "static-1.6005",
  "usage-tracker-public": "static-1.7399",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3932",
  "reference-resolvers": "static-1.8413",
  "ui-extensibility-client-types": "static-1.4151",
  "hubspot-apollo-cache": "static-1.567",
  "universal-page-editor-lib": "static-1.3241",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.73",
  "simple-data-table": "static-1.3406",
  "atom": "static-1.5307",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10871",
  "ui-addon-draggable": "static-3.4987",
  "content-assistance-lib": "static-1.8107",
  "content-media-capture": "static-1.5246",
  "customer-data-ui-utilities": "static-1.10057",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24315",
  "growth-payments-core": "static-1.26035",
  "knowledge-content-types": "static-1.8614",
  "payment-link-components": "static-1.24044",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20210",
  "ui-addon-emoji-picker": "static-1.10117",
  "ui-business-units-lib": "static-1.9312",
  "video-components-external": "static-1.12009",
  "video-data-lib": "static-1.35667",
  "navigation-messaging": "static-1.8017",
  "collaboration-sidebar": "static-1.58567",
  "react-dnd-compat": "static-1.4846",
  "batch-promise": "static-1.1775",
  "crm-component-utils": "static-1.39699",
  "crm-properties-common-lib": "static-1.6120",
  "customer-data-properties": "static-1.52377",
  "external-options-client-types": "static-1.4287",
  "framework-data-schema-resolvers": "static-1.7124",
  "property-value-citations": "static-1.2991",
  "reference-resolvers-lite": "static-1.8330",
  "hubspotter-http-shared-msw-handlers": "static-1.10494",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5045",
  "content-icons-ui": "static-1.2297",
  "breeze-artifacts-sdk": "static-1.124",
  "onboarding-journeys-lib": "static-1.747",
  "pulse": "static-1.855",
  "conversations-skeleton-state": "static-1.7480",
  "crm-message-bus": "static-1.43594",
  "customer-data-filters-ui-msw-helpers": "static-1.23129",
  "events-data-lib": "static-1.474",
  "FormUrlGenerator": "static-2.4956",
  "framework-builder-read-service-client": "static-1.4168",
  "framework-data-schema-quick-fetch": "static-1.7029",
  "multi-account-reference-resolvers": "static-1.1229",
  "onboarding-tours": "static-1.17014",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14334",
  "academy-common-lib": "static-1.14752",
  "dashboard-lib": "static-1.82511",
  "getting-started-shared-tasks": "static-1.19075",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8935",
  "ui-asset-management-lib": "static-1.11320",
  "user-context": "static-1.5343",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68187",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.951",
  "nest": "static-1.468",
  "breeze-engine-chat-components": "static-1.506",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.132",
  "framework-listing-lib": "static-2.29336",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31278",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4485",
  "onboarding-scopes": "static-1.6688",
  "purchase-motions-api": "static-1.6267",
  "signup-constants": "static-1.19457",
  "signup-ui-url-generator": "static-2.8289",
  "onboarding-tours-client": "static-1.5228",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7832",
  "subscription-experience-data-types": "static-1.15176",
  "crm-record-cards-service-types": "static-1.3741",
  "location-customization-utils-lib": "static-1.9954",
  "redux-thunk": "static-2.75",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29179",
  "content-media-composition-data-lib": "static-1.13050",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4655",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.572",
  "ui-addon-opt": "static-4.8593",
  "commerce-tours-lib": "static-1.6509",
  "growth-onboarding-reliability": "static-1.5311",
  "sales-checkout-service-client": "static-1.3767",
  "data-token-picker": "static-1.16792",
  "FileManagerLib": "static-1.39955",
  "content-media-compositions": "static-2.17057",
  "media-bridge-lib": "static-1.19312",
  "chatspot-widget-iframe": "static-1.22537",
  "collaboration-sidebar-common": "static-1.3364",
  "marketing-platform-lib": "static-1.7099",
  "card-properties-lib": "static-1.44867",
  "commerce-subscription-lib": "static-1.37641",
  "crm-actions": "static-1.6581",
  "crm-cards-sdk": "static-1.44330",
  "customer-data-properties-shared-msw-handlers": "static-1.9823",
  "customer-data-tracking": "static-1.7113",
  "hs-resources": "static-1.419",
  "calling-global-api": "static-1.65304",
  "calling-internal-common": "static-1.31547",
  "calling-lifecycle-internal": "static-1.66686",
  "calling-lifecycle-messages": "static-1.58980",
  "commerce-products-lib": "static-1.10366",
  "conditional-properties-service-client": "static-1.3959",
  "crm-links": "static-1.6550",
  "crm-index-visualization-core": "static-1.4450",
  "crm-pipelines-api-client-types": "static-1.4296",
  "formula-editor": "static-1.14649",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4373",
  "meetings-icalendar-utils-lib": "static-1.866",
  "multi-currency-client-types": "static-1.3853",
  "object-builder-ui-client": "static-1.49479",
  "pipeline-validation-client-types": "static-1.4128",
  "smart-property-lib": "static-1.8140",
  "tiered-pricing": "static-1.1831",
  "topics-actions-lib": "static-1.389",
  "ui-addon-form-validation": "static-1.11217",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.243",
  "bend-plugin-pulse": "static-1.358",
  "event-emitter": "static-1.1183",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1497",
  "growth-data-modal": "static-1.5793",
  "growth-onboarding-confetti": "static-1.3292",
  "growth-onboarding-next-action-utils": "static-1.2559",
  "onboarding-tours-utils": "static-1.1080",
  "ui-shepherd-tracker": "static-1.7874",
  "academy-service-client": "static-1.3921",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39814",
  "SafeStorage": "static-1.4634",
  "video-embed": "static-1.36501",
  "redux-actions": "static-3.67",
  "EmailSignatureEditor": "static-1.24883",
  "viral-links-lib": "static-1.7304",
  "nested-table": "static-1.465",
  "timezone-utils": "static-2.5477",
  "getting-started-shared-tasks-store": "static-1.18193",
  "campaign-roi-lib": "static-1.9947",
  "ui-addon-calendars": "static-2.5557",
  "customer-data-views-management": "static-1.25906",
  "framework-data-table": "static-2.12417",
  "nudge-client-utils": "static-1.3041",
  "nudge-custom-ui-functions": "static-1.1394",
  "switchboard-lib": "static-1.446",
  "access-check-ui-lib": "static-1.1447",
  "app-users-service-client": "static-1.5849",
  "app-users-service-types": "static-1.5257",
  "mini-checkout-client": "static-1.27400",
  "onboarding-utils": "static-1.5593",
  "permissions-shared-i18n-strings-fe": "static-1.2105",
  "ui-coaching-tips-shared-config": "static-1.29164",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7078",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3716",
  "edison-service-client-types": "static-1.620",
  "growth-onboarding-feedback-components": "static-1.6813",
  "audio-components": "static-1.6249",
  "FileManagerImages": "static-1.37466",
  "video-components": "static-1.14011",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92700",
  "customer-data-sidebar": "static-2.46611",
  "enrichment-properties-lib": "static-1.17711",
  "ui-addon-draggable-compat": "static-2.4492",
  "universal-record-utils-lib": "static-1.1673",
  "commerce-billing-lib": "static-1.19904",
  "commerce-shared-components-lib": "static-1.19099",
  "commerce-tools-ui-lib": "static-1.10927",
  "crm-fe-perf": "static-1.23130",
  "calling-error-reporting": "static-1.31554",
  "shared-worker-versioning": "static-1.11270",
  "calling-usage-tracker": "static-1.6770",
  "voice-sms-access-library": "static-1.1826",
  "commerce-permissions": "static-1.1007",
  "products-iframe-lib": "static-1.8464",
  "products-ui-components-shared-msw-handlers": "static-1.10878",
  "crm-index-associations-lib": "static-1.6672",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10579",
  "sales-views-client-types": "static-1.4488",
  "bark-lib": "static-1.16736",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.547",
  "policy-lib": "static-1.7024",
  "react-tinymce": "static-1.55839",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10642",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54965",
  "tinymce-plugins": "static-1.58079",
  "tinymce-themes": "static-1.56935",
  "onboarding-data-sync-lib": "static-1.2363",
  "growth-onboarding-next-action-components": "static-1.2587",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4764",
  "outpost": "static-1.4392",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22059",
  "sales-email-signature-service-client": "static-1.4076",
  "ts-utils-lib": "static-1.406",
  "crm-export-dialog": "static-1.6516",
  "crm-view-components": "static-1.955",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7562",
  "nudge-custom-function-registry": "static-1.2798",
  "nudge-renderer-utils": "static-1.3117",
  "whisper-core-api": "static-1.7187",
  "InboxConnectUtils": "static-4.15422",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46711",
  "hub-http-rxjs": "static-1.828",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4222",
  "company-details-components": "static-1.6432",
  "react-performance-metrics-lib": "static-1.785",
  "pricing-pages-ui-components": "static-1.15377",
  "quote-checkout-service-types": "static-1.3686",
  "social-insights-client-types": "static-1.22673",
  "crm_universal": "static-1.22398",
  "customer-data-email": "static-1.18426",
  "card-payment-highlight-lib": "static-1.37833",
  "card-subscription-highlight-lib": "static-1.40064",
  "commerce-contract-lib": "static-1.13101",
  "invoices-highlight-card-lib": "static-1.55476",
  "orders-highlight-card-lib": "static-1.22055",
  "products-highlight-card-lib": "static-1.18649",
  "quotes-highlight-card-lib": "static-1.72702",
  "crm-source-interpretation-lib": "static-1.5564",
  "crm-object-search-query-utilities": "static-1.10083",
  "utility-belt": "static-1.2763",
  "payments-enrollment-embed-lib": "static-1.23679",
  "stripe-embedded-components": "static-1.7898",
  "customer-data-rte": "static-1.33530",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6167",
  "payments-post-enroll-local-storage-lib": "static-1.5338",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38792",
  "calling-orchestration-schema": "static-1.36603",
  "react-reducer-toolkit": "static-1.16233",
  "hub-http-contrib": "static-1.3270",
  "interframe": "static-3.4986",
  "tinymce-data": "static-1.41050",
  "ui-addon-sales-email": "static-1.5444",
  "layout-dnd-components": "static-1.12865",
  "layout-dnd-utils": "static-1.11840",
  "ui-brand-identity-lib": "static-1.16157",
  "NamespacedHubStyle": "static-2.9211",
  "meetings-connect-utils-lib": "static-1.7838",
  "access-control-lib": "static-1.10668",
  "EmailComponents": "static-1.55416",
  "EmailData": "static-1.54094",
  "redux-less": "static-2.9711",
  "company-details-service-types": "static-1.4170",
  "segments-query-core": "static-1.1654",
  "pricing-pages-api": "static-1.15242",
  "sequences-lib": "static-1.8424",
  "ui-gdpr-components": "static-1.10585",
  "products-ui-components": "static-1.40884",
  "accounting-integrations-ui-components": "static-1.7440",
  "invoices-ui-lib": "static-1.55492",
  "commerce-products-api": "static-1.2619",
  "invoices-iframe-lib": "static-1.57550",
  "quotes-modal-lib": "static-1.103380",
  "quotes-ui-lib": "static-1.81423",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28794",
  "ContentData": "static-1.69095",
  "layout-data-lib": "static-1.10165",
  "ContentComponents": "static-2.71976",
  "marketing-contacts-lib": "static-1.10824",
  "marketing-email-service-types": "static-1.2060",
  "messaging-editing-lib": "static-1.46992",
  "messaging-usage-based-billing-components-lib": "static-1.1854",
  "automation-ui-source-apps": "static-1.19529",
  "automation-ui-types": "static-1.20447",
  "messaging-types-lib": "static-1.46729",
  "onboarding-settings-client": "static-1.4740",
  "sequences-client-types-lib": "static-1.8281",
  "commerce-tax-lib": "static-1.772",
  "price-books-api": "static-1.1586",
  "price-books-components": "static-1.1644",
  "property-description-translator": "static-1.4068",
  "ramp-editor": "static-1.765",
  "commerce-analytics-service-client": "static-1.3755",
  "totals-ui-components": "static-1.24175",
  "SalesContentIndexUI": "static-3.9547",
  "advanced-menus-core": "static-1.15490",
  "advanced-menus-lib": "static-1.12375",
  "ui-memberships-settings-lib": "static-1.34674",
  "automation-ui-ubb": "static-1.6363",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7565",
  "data-token-views": "static-1.16773",
  "forms-utils-lib": "static-1.12993",
  "payments-embed-points-lib": "static-1.13481",
  "simple-menus-core": "static-1.15489",
  "simple-menus-lib": "static-1.17006",
  "videoconference-integration-components": "static-1.7153",
  "marketing-contacts-client": "static-1.7738",
  "mc-hard-limits-client-types": "static-1.132",
  "automation-applications-service-types": "static-1.3637",
  "automation-platform-service-types": "static-1.2648",
  "ContentEditorUI": "static-2.77755",
  "short-messages-app-service-client": "static-1.4151",
  "web-interactives-components": "static-1.14148",
  "web-interactives-data": "static-1.14149",
  "messaging-shared-utils-lib": "static-1.1303",
  "messaging-user-info-utils-lib": "static-1.1473",
  "email-portal-health-service-types": "static-1.1209",
  "line-items-api": "static-1.1016",
  "commerce-totals-service-types": "static-1.3978",
  "FireAlarmUi": "static-1.4669",
  "sales-templates-service-types-lib": "static-1.4329",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22383",
  "automation-ui-usage-tracking": "static-1.21846",
  "data-studio-ubb": "static-1.3378",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27539",
  "content-management-data-lib": "static-1.5843",
  "copilot-plugins": "static-1.11682",
  "cta-picker": "static-1.36962",
  "customer-agent-discovery-components-lib": "static-1.3748",
  "editor-components": "static-1.13554",
  "editor-iframe-lib": "static-1.8712",
  "error-messaging-js": "static-1.5425",
  "FormsCommonComponents": "static-1.86449",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10880",
  "SharedLegalStrings": "static-1.1976",
  "smart-content-core": "static-1.43044",
  "smart-content-lib": "static-1.43697",
  "social-composer-lib": "static-1.60020",
  "structured-content-lib": "static-1.25789",
  "theme-previewer-lib": "static-1.53817",
  "tinymce-copilot": "static-1.17033",
  "xray-recommendation-lib": "static-1.8189",
  "automation-ui-routing": "static-1.21804",
  "sql-reporting-client-types": "static-1.5835",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42673",
  "campaigns-utils-lib": "static-1.3429",
  "reporting-enablement": "static-1.23672",
  "forms-ai-lib": "static-1.4665",
  "codemirror-dlb": "static-1.59314",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6670",
  "report-customization-components": "static-1.13764",
  "data-quality-ui-library": "static-1.13639",
  "reporting-filters": "static-1.879",
  "reporting-insights-lib": "static-1.2423"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13073",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9888",
  "foundations-components": "/foundations-components/static-1.8358",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1383",
  "foundations-theming": "/foundations-theming/static-1.4684",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8256",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10496",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11711",
  "I18n": "/I18n/static-7.1655",
  "jasmine-runner": "/jasmine-runner/static-1.6679",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.520",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13136",
  "quartz": "/quartz/static-1.7341",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16937",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3086",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10442",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12751",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7532",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11377",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9764",
  "unified-auth": "/unified-auth/static-1.768",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1050",
  "usage-tracker": "/usage-tracker/static-1.7588",
  "usage-tracker-core": "/usage-tracker-core/static-1.7438",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8329",
  "hub-http": "/hub-http/static-1.6444",
  "integrations-lib": "/integrations-lib/static-1.16880",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20523",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.509",
  "property-management-iframe": "/property-management-iframe/static-1.13925",
  "quartz-config": "/quartz-config/static-1.1119",
  "quartz-core": "/quartz-core/static-1.6560",
  "quartz-routing": "/quartz-routing/static-1.771",
  "quick-fetch": "/quick-fetch/static-1.4078",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4893",
  "ts-schema": "/ts-schema/static-1.4240",
  "ui-universal-auth": "/ui-universal-auth/static-1.9254",
  "UIComponents": "/UIComponents/static-3.8657",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3561",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3618",
  "quartz-webpack": "/quartz-webpack/static-1.3565",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.419",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4627",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5106",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2400",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9657",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.55",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5502",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2416",
  "ui-fonts": "/ui-fonts/static-1.973",
  "ui-images": "/ui-images/static-2.1223",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3167",
  "foundations-theming-base": "/foundations-theming-base/static-1.3669",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.785",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3367",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4549",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8937",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9544",
  "ai-rendering-library": "/ai-rendering-library/static-1.10962",
  "chirp-fetch": "/chirp-fetch/static-1.2118",
  "connections-embed-lib": "/connections-embed-lib/static-1.1409",
  "copilot-toolkit": "/copilot-toolkit/static-1.11710",
  "feedback-loader": "/feedback-loader/static-1.29707",
  "laboratory-lib": "/laboratory-lib/static-3.7382",
  "marketplace-embed": "/marketplace-embed/static-1.22776",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10418",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20478",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14693",
  "sanitize-text": "/sanitize-text/static-1.8379",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6002",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5274",
  "wootric-nps": "/wootric-nps/static-1.7147",
  "quartz-head": "/quartz-head/static-1.1006",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4888",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4382",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2636",
  "reporting-data": "/reporting-data/static-1.68509",
  "cssUtils": "/cssUtils/static-1.862",
  "flux-actions": "/flux-actions/static-1.357",
  "HubStyle": "/HubStyle/static-2.12018",
  "PatternValidationJS": "/PatternValidationJS/static-1.3126",
  "react-colorpicker": "/react-colorpicker/static-2.10438",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.71",
  "ReduxMessenger": "/ReduxMessenger/static-2.10596",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7578",
  "icons": "/icons/static-2.672",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19055",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4741",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5841",
  "quartz-i18n": "/quartz-i18n/static-1.1016",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.315",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.893",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.894",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1039",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.338",
  "slack-ui-library": "/slack-ui-library/static-1.10626",
  "fsm": "/fsm/static-1.3968",
  "customer-data-objects": "/customer-data-objects/static-1.7915",
  "property-translator": "/property-translator/static-1.5624",
  "hs-locale-management": "/hs-locale-management/static-1.242",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8159",
  "hs-promise-utils": "/hs-promise-utils/static-1.5826",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5108",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14296",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5839",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8008",
  "sanitize": "/sanitize/static-1.4707",
  "superstore": "/superstore/static-1.4987",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10493",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8230",
  "hub-http-janus": "/hub-http-janus/static-1.863",
  "hubspotter-http": "/hubspotter-http/static-1.4810",
  "immutable-less": "/immutable-less/static-1.4882",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17930",
  "nav-meta": "/nav-meta/static-1.30327",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18302",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.852",
  "ai-studio-lib": "/ai-studio-lib/static-1.12305",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.382",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9307",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8256",
  "ui-product-approvals": "/ui-product-approvals/static-1.28957",
  "ui-tool-access": "/ui-tool-access/static-1.10384",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
  "property-management-common": "/property-management-common/static-1.6213",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.560",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1016",
  "quartz-test": "/quartz-test/static-1.1016",
  "quartz-tracking": "/quartz-tracking/static-1.720",
  "trellis-components": "/trellis-components/static-1.2435",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.303",
  "bender-build-tools": "/bender-build-tools/static-1.3356",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22546",
  "ContentUtils": "/ContentUtils/static-1.69020",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13262",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2728",
  "breeze-engine-core": "/breeze-engine-core/static-1.806",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.580",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40694",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13409",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15292",
  "ExportDialog": "/ExportDialog/static-6.10611",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41876",
  "reporting-snowflake": "/reporting-snowflake/static-1.57127",
  "reporting-ui-components": "/reporting-ui-components/static-2.65780",
  "reporting-visualizations": "/reporting-visualizations/static-1.60585",
  "trellis-theming": "/trellis-theming/static-1.1186",
  "ui-addon-teams": "/ui-addon-teams/static-1.21837",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.436",
  "magpie-lib": "/magpie-lib/static-1.5710",
  "navigation-components": "/navigation-components/static-1.18690",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1528",
  "magpie-types": "/magpie-types/static-1.5170",
  "simple-logging-lib": "/simple-logging-lib/static-1.3280",
  "fail-safe": "/fail-safe/static-1.181",
  "app-governance-lib": "/app-governance-lib/static-1.2256",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10729",
  "purchase-motions-components": "/purchase-motions-components/static-1.6264",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9932",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6005",
  "usage-tracker-public": "/usage-tracker-public/static-1.7399",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3932",
  "reference-resolvers": "/reference-resolvers/static-1.8413",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4151",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.567",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3241",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.73",
  "simple-data-table": "/simple-data-table/static-1.3406",
  "atom": "/atom/static-1.5307",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10871",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4987",
  "content-assistance-lib": "/content-assistance-lib/static-1.8107",
  "content-media-capture": "/content-media-capture/static-1.5246",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10057",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24315",
  "growth-payments-core": "/growth-payments-core/static-1.26035",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "payment-link-components": "/payment-link-components/static-1.24044",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20210",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10117",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9312",
  "video-components-external": "/video-components-external/static-1.12009",
  "video-data-lib": "/video-data-lib/static-1.35667",
  "navigation-messaging": "/navigation-messaging/static-1.8017",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58567",
  "react-dnd-compat": "/react-dnd-compat/static-1.4846",
  "batch-promise": "/batch-promise/static-1.1775",
  "crm-component-utils": "/crm-component-utils/static-1.39699",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6120",
  "customer-data-properties": "/customer-data-properties/static-1.52377",
  "external-options-client-types": "/external-options-client-types/static-1.4287",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7124",
  "property-value-citations": "/property-value-citations/static-1.2991",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8330",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10494",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5045",
  "content-icons-ui": "/content-icons-ui/static-1.2297",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.124",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.747",
  "pulse": "/pulse/static-1.855",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7480",
  "crm-message-bus": "/crm-message-bus/static-1.43594",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23129",
  "events-data-lib": "/events-data-lib/static-1.474",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4956",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4168",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7029",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1229",
  "onboarding-tours": "/onboarding-tours/static-1.17014",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14334",
  "academy-common-lib": "/academy-common-lib/static-1.14752",
  "dashboard-lib": "/dashboard-lib/static-1.82511",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19075",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8935",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11320",
  "user-context": "/user-context/static-1.5343",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68187",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.951",
  "nest": "/nest/static-1.468",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.506",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.132",
  "framework-listing-lib": "/framework-listing-lib/static-2.29336",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31278",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4485",
  "onboarding-scopes": "/onboarding-scopes/static-1.6688",
  "purchase-motions-api": "/purchase-motions-api/static-1.6267",
  "signup-constants": "/signup-constants/static-1.19457",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8289",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5228",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7832",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15176",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3741",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9954",
  "redux-thunk": "/redux-thunk/static-2.75",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29179",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13050",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4655",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.572",
  "ui-addon-opt": "/ui-addon-opt/static-4.8593",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6509",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5311",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3767",
  "data-token-picker": "/data-token-picker/static-1.16792",
  "FileManagerLib": "/FileManagerLib/static-1.39955",
  "content-media-compositions": "/content-media-compositions/static-2.17057",
  "media-bridge-lib": "/media-bridge-lib/static-1.19312",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22537",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3364",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7099",
  "card-properties-lib": "/card-properties-lib/static-1.44867",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37641",
  "crm-actions": "/crm-actions/static-1.6581",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44330",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9823",
  "customer-data-tracking": "/customer-data-tracking/static-1.7113",
  "hs-resources": "/hs-resources/static-1.419",
  "calling-global-api": "/calling-global-api/static-1.65304",
  "calling-internal-common": "/calling-internal-common/static-1.31547",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66686",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58980",
  "commerce-products-lib": "/commerce-products-lib/static-1.10366",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3959",
  "crm-links": "/crm-links/static-1.6550",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4450",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4296",
  "formula-editor": "/formula-editor/static-1.14649",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4373",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.866",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3853",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49479",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4128",
  "smart-property-lib": "/smart-property-lib/static-1.8140",
  "tiered-pricing": "/tiered-pricing/static-1.1831",
  "topics-actions-lib": "/topics-actions-lib/static-1.389",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11217",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.243",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.358",
  "event-emitter": "/event-emitter/static-1.1183",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1497",
  "growth-data-modal": "/growth-data-modal/static-1.5793",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3292",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2559",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1080",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7874",
  "academy-service-client": "/academy-service-client/static-1.3921",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39814",
  "SafeStorage": "/SafeStorage/static-1.4634",
  "video-embed": "/video-embed/static-1.36501",
  "redux-actions": "/redux-actions/static-3.67",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24883",
  "viral-links-lib": "/viral-links-lib/static-1.7304",
  "nested-table": "/nested-table/static-1.465",
  "timezone-utils": "/timezone-utils/static-2.5477",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18193",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9947",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5557",
  "customer-data-views-management": "/customer-data-views-management/static-1.25906",
  "framework-data-table": "/framework-data-table/static-2.12417",
  "nudge-client-utils": "/nudge-client-utils/static-1.3041",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1394",
  "switchboard-lib": "/switchboard-lib/static-1.446",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1447",
  "app-users-service-client": "/app-users-service-client/static-1.5849",
  "app-users-service-types": "/app-users-service-types/static-1.5257",
  "mini-checkout-client": "/mini-checkout-client/static-1.27400",
  "onboarding-utils": "/onboarding-utils/static-1.5593",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2105",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29164",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7078",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3716",
  "edison-service-client-types": "/edison-service-client-types/static-1.620",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6813",
  "audio-components": "/audio-components/static-1.6249",
  "FileManagerImages": "/FileManagerImages/static-1.37466",
  "video-components": "/video-components/static-1.14011",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92700",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46611",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17711",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4492",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1673",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19904",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19099",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10927",
  "crm-fe-perf": "/crm-fe-perf/static-1.23130",
  "calling-error-reporting": "/calling-error-reporting/static-1.31554",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11270",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6770",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1826",
  "commerce-permissions": "/commerce-permissions/static-1.1007",
  "products-iframe-lib": "/products-iframe-lib/static-1.8464",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10878",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6672",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10579",
  "sales-views-client-types": "/sales-views-client-types/static-1.4488",
  "bark-lib": "/bark-lib/static-1.16736",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.547",
  "policy-lib": "/policy-lib/static-1.7024",
  "react-tinymce": "/react-tinymce/static-1.55839",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10642",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54965",
  "tinymce-plugins": "/tinymce-plugins/static-1.58079",
  "tinymce-themes": "/tinymce-themes/static-1.56935",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2363",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2587",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4764",
  "outpost": "/outpost/static-1.4392",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22059",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4076",
  "ts-utils-lib": "/ts-utils-lib/static-1.406",
  "crm-export-dialog": "/crm-export-dialog/static-1.6516",
  "crm-view-components": "/crm-view-components/static-1.955",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7562",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2798",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3117",
  "whisper-core-api": "/whisper-core-api/static-1.7187",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15422",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46711",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.828",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4222",
  "company-details-components": "/company-details-components/static-1.6432",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.785",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15377",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3686",
  "social-insights-client-types": "/social-insights-client-types/static-1.22673",
  "crm_universal": "/crm_universal/static-1.22398",
  "customer-data-email": "/customer-data-email/static-1.18426",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37833",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40064",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13101",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55476",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22055",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18649",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72702",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5564",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10083",
  "utility-belt": "/utility-belt/static-1.2763",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23679",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7898",
  "customer-data-rte": "/customer-data-rte/static-1.33530",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6167",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5338",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38792",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36603",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16233",
  "hub-http-contrib": "/hub-http-contrib/static-1.3270",
  "interframe": "/interframe/static-3.4986",
  "tinymce-data": "/tinymce-data/static-1.41050",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5444",
  "layout-dnd-components": "/layout-dnd-components/static-1.12865",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11840",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16157",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9211",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7838",
  "access-control-lib": "/access-control-lib/static-1.10668",
  "EmailComponents": "/EmailComponents/static-1.55416",
  "EmailData": "/EmailData/static-1.54094",
  "redux-less": "/redux-less/static-2.9711",
  "company-details-service-types": "/company-details-service-types/static-1.4170",
  "segments-query-core": "/segments-query-core/static-1.1654",
  "pricing-pages-api": "/pricing-pages-api/static-1.15242",
  "sequences-lib": "/sequences-lib/static-1.8424",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10585",
  "products-ui-components": "/products-ui-components/static-1.40884",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7440",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55492",
  "commerce-products-api": "/commerce-products-api/static-1.2619",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57550",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103380",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81423",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28794",
  "ContentData": "/ContentData/static-1.69095",
  "layout-data-lib": "/layout-data-lib/static-1.10165",
  "ContentComponents": "/ContentComponents/static-2.71976",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10824",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46992",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1854",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19529",
  "automation-ui-types": "/automation-ui-types/static-1.20447",
  "messaging-types-lib": "/messaging-types-lib/static-1.46729",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4740",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8281",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.772",
  "price-books-api": "/price-books-api/static-1.1586",
  "price-books-components": "/price-books-components/static-1.1644",
  "property-description-translator": "/property-description-translator/static-1.4068",
  "ramp-editor": "/ramp-editor/static-1.765",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3755",
  "totals-ui-components": "/totals-ui-components/static-1.24175",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9547",
  "advanced-menus-core": "/advanced-menus-core/static-1.15490",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12375",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34674",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6363",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7565",
  "data-token-views": "/data-token-views/static-1.16773",
  "forms-utils-lib": "/forms-utils-lib/static-1.12993",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13481",
  "simple-menus-core": "/simple-menus-core/static-1.15489",
  "simple-menus-lib": "/simple-menus-lib/static-1.17006",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7153",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7738",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.132",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3637",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2648",
  "ContentEditorUI": "/ContentEditorUI/static-2.77755",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4151",
  "web-interactives-components": "/web-interactives-components/static-1.14148",
  "web-interactives-data": "/web-interactives-data/static-1.14149",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1303",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1473",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1209",
  "line-items-api": "/line-items-api/static-1.1016",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3978",
  "FireAlarmUi": "/FireAlarmUi/static-1.4669",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4329",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22383",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21846",
  "data-studio-ubb": "/data-studio-ubb/static-1.3378",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27539",
  "content-management-data-lib": "/content-management-data-lib/static-1.5843",
  "copilot-plugins": "/copilot-plugins/static-1.11682",
  "cta-picker": "/cta-picker/static-1.36962",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3748",
  "editor-components": "/editor-components/static-1.13554",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8712",
  "error-messaging-js": "/error-messaging-js/static-1.5425",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86449",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10880",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1976",
  "smart-content-core": "/smart-content-core/static-1.43044",
  "smart-content-lib": "/smart-content-lib/static-1.43697",
  "social-composer-lib": "/social-composer-lib/static-1.60020",
  "structured-content-lib": "/structured-content-lib/static-1.25789",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53817",
  "tinymce-copilot": "/tinymce-copilot/static-1.17033",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8189",
  "automation-ui-routing": "/automation-ui-routing/static-1.21804",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5835",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42673",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3429",
  "reporting-enablement": "/reporting-enablement/static-1.23672",
  "forms-ai-lib": "/forms-ai-lib/static-1.4665",
  "codemirror-dlb": "/codemirror-dlb/static-1.59314",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6670",
  "report-customization-components": "/report-customization-components/static-1.13764",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13639",
  "reporting-filters": "/reporting-filters/static-1.879",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2423"
}
};
